<template>
  <main class="mx-auto custom-container-forum">
    <h3 class="py-1 my-6">{{ $t("forum.listForums.title") }}</h3>
    <TabView
      class="!pb-0 custom-tabsForum"
      @tab-change="changeTab"
      :lazy="true"
    >
      <TabPanel v-for="(tab, i) in tabs" :key="i">
        <template #header>
          <div class="w-full mx-8 text-center">
            <span>{{ tab.title }}</span>
          </div>
        </template>
        <component :is="tab.component" class="mt-8"></component>
      </TabPanel>
    </TabView>
  </main>
</template>

<script lang="ts">
import { QueryParams } from "@/models/query-params.model";
import { defineComponent, defineAsyncComponent, markRaw } from "vue";

const ListForums = markRaw(
  defineAsyncComponent(() => import("./ListForums/list-forum.vue"))
);
const ListDenounces = markRaw(
  defineAsyncComponent(() => import("./ListDenounces/list-denounces.vue"))
);

export default defineComponent({
  name: "list-forums",
  components: {
    ListForums,
    ListDenounces,
  },
  data() {
    return {
      params: new QueryParams(),
      tabs: [
        {
          title: this.$t("labels.generic", {
            pt: "Lista de fóruns",
            en: "List of forums",
          }),
          component: ListForums,
        },
        {
          title: this.$t("labels.generic", {
            pt: "Denúncias",
            en: "Reports",
          }),
          component: ListDenounces,
        },
      ],
    };
  },
  methods: {
    changeTab(): void {
      this.params.page = 0;
      this.params.title = undefined;
      this.params.name = undefined;
      this.$router.push({
        name: "listForums",
        query: {
          ...this.$route.query,
          page: this.params.page,
          title: this.params.title,
          name: this.params.name,
        },
      });
    },
  },
});
</script>
